/**
 * Australian visa subclasses we surface in the platform.
 * Source: Department of Home Affairs.
 * See docs/07_DATA_SOURCES.md for the canonical list.
 */

export type VisaPurpose =
  | 'study'
  | 'post_study_work'
  | 'skilled_temporary'
  | 'skilled_permanent'
  | 'skilled_state_nominated'
  | 'skilled_regional'
  | 'skilled_employer_regional'
  | 'employer_sponsored_permanent';

export type VisaSubclass = {
  readonly subclass: string;
  readonly name: string;
  readonly purpose: VisaPurpose;
};

export const VISA_SUBCLASSES: readonly VisaSubclass[] = [
  { subclass: '500', name: 'Student visa', purpose: 'study' },
  { subclass: '485', name: 'Temporary Graduate visa', purpose: 'post_study_work' },
  { subclass: '482', name: 'Skills in Demand visa', purpose: 'skilled_temporary' },
  {
    subclass: '186',
    name: 'Employer Nomination Scheme visa',
    purpose: 'employer_sponsored_permanent',
  },
  { subclass: '189', name: 'Skilled Independent visa', purpose: 'skilled_permanent' },
  { subclass: '190', name: 'Skilled Nominated visa', purpose: 'skilled_state_nominated' },
  {
    subclass: '491',
    name: 'Skilled Work Regional (Provisional) visa',
    purpose: 'skilled_regional',
  },
  {
    subclass: '494',
    name: 'Skilled Employer Sponsored Regional visa',
    purpose: 'skilled_employer_regional',
  },
] as const;

export const VISA_SUBCLASS_CODES = VISA_SUBCLASSES.map((v) => v.subclass);
